import { api } from '@/api/api';
import { ContactDBInstance } from './contact_dbl';
import ContactUtilInterface from './contact_util';
import { ContactTransformInstance } from './contact_transform';
import { apis } from '@/config';
import { ContactServerCommon } from './contact_server_common';
import { ContactServerEnterprise } from './contact_server_enterprise';
import { ContactServerPersonal } from './contact_server_personal';
import { ContactServerCustomer } from './contact_server_customer';
import { ContactServerMaillist } from './contact_server_maillist';
import { ContactEventHub } from './util/event_hub';
export class ContactServer {
    constructor() {
        this.systemApi = api.getSystemApi();
        this.store = api.getDataStoreApi();
        this.http = api.getDataTransApi();
        this.contactDB = ContactDBInstance;
        this.memoryApi = api.requireLogicalApi(apis.dbMemoryApiImpl);
        this.contactUtil = ContactUtilInterface;
        this.contactTrans = ContactTransformInstance;
        this.dataTrackerApi = api.requireLogicalApi(apis.dataTrackerApiImp);
        this.loggerApi = api.requireLogicalApi(apis.loggerApiImpl);
        this.eventApi = api.getEventApi();
        this.productApi = api.requireLogicalApi(apis.productAuthApiImpl);
        this.selfCustomerSyncLastTime = 'server_sync_self_customer_last_time_';
        this.selfCustomerSyncLastId = 'server_sync_self_customer_last_id_';
        this.customerSyncLastTime = 'server_sync_customer_last_time_';
        this.customerSyncLastId = 'server_sync_customer_last_id_';
        this.clueSyncLastTime = 'server_sync_clue_last_time_';
        this.clueSyncLastId = 'server_sync_clue_last_id_';
        this.contactGlobalDB = 'contact_global_db_upgrade_version';
        this.syncPullVersionCustomer = 'sync_pull_version_customer';
        this.syncPullVersionClue = 'sync_pull_version_clue';
        this.contactServerUrlMap = {
            enterpriseNew: 'getFullEnterpriseContactList',
            enterprise: 'getEnterpriseContactList',
            personal: 'getPersonContactList',
            org: 'getOrgList',
            personalOrg: 'getPersonalOrgList',
        };
        this.ctx = {
            systemApi: this.systemApi,
            store: this.store,
            http: this.http,
            contactDB: this.contactDB,
            contactUtil: this.contactUtil,
            contactTrans: this.contactTrans,
            dataTrackerApi: this.dataTrackerApi,
            loggerApi: this.loggerApi,
            eventApi: this.eventApi,
            productApi: this.productApi,
            eventHub: new ContactEventHub(this.eventApi),
            memoryApi: this.memoryApi,
        };
        this.common = new ContactServerCommon(this.ctx);
        this.enterprise = new ContactServerEnterprise(this.ctx, this.common);
        this.personal = new ContactServerPersonal(this.ctx, this.common);
        this.customer = new ContactServerCustomer(this.ctx, this.common);
        this.maillist = new ContactServerMaillist(this.ctx);
    }
    get enterpriseModule() {
        return this.enterprise;
    }
    getDomain(email) {
        return this.common.getDomain(email);
    }
    resolveDomain(enterpriseId, _account) {
        return this.common.resolveDomain(enterpriseId, _account);
    }
    getAllDomains(_account) {
        return this.common.getAllDomains(_account);
    }
    getEmail(email) {
        return this.common.getEmail(email);
    }
    getStoreData(key) {
        return this.common.getStoreData(key);
    }
    async getStoreSource() {
        return this.common.getStoreSource();
    }
    async getSyncServerParams(options) {
        return this.common.getSyncServerParams(options);
    }
    syncListAliasName(from) {
        return this.common.syncListAliasName(from);
    }
    async searchContactByServer(query) {
        return this.common.searchContactByServer(query);
    }
    async searchEnterpriseContacts(keyword, domain, limit) {
        return this.common.searchEnterpriseContacts(keyword, domain, limit);
    }
    async getContactsByUnitId(query) {
        return this.common.getContactsByUnitId(query);
    }
    async getContactByQiyeAccountId(query) {
        return this.common.getContactByQiyeAccountId(query);
    }
    async getEnterpriseContactDetail(params) {
        return this.common.getEnterpriseContactDetail(params);
    }
    async getEnterpriseContactBase(params) {
        return this.common.getEnterpriseContactBase(params);
    }
    async doSearch(condition) {
        return this.common.doSearch(condition);
    }
    async doSearchAllContact(condition) {
        return this.common.doSearchAllContact(condition);
    }
    async getContactByYunxin(accounts, _account) {
        return this.common.getContactByYunxin(accounts, _account);
    }
    async doGetContactByYunxin(accounts, _account) {
        return this.common.doGetContactByYunxin(accounts, _account);
    }
    transServer2ContactModel(params) {
        return this.common.transServer2ContactModel(params);
    }
    async doGetContactByEmails(emails, _account, uniqueEmail) {
        return this.common.doGetContactByEmails(emails, _account, uniqueEmail);
    }
    async doGetContactByOrgId(params) {
        return this.common.doGetContactByOrgId(params);
    }
    async getOrgDetailByServer(lastUpdateTime) {
        return this.common.getOrgDetailByServer(lastUpdateTime);
    }
    async getContactByServer(lastUpdateTime) {
        return this.common.getContactByServer(lastUpdateTime);
    }
    async retry(fn, count = 3) {
        return this.common.retry(fn, count);
    }
    async getRecentContactListInServer(params) {
        return this.common.getRecentContactListInServer(params);
    }
    async doSyncCoreContactData(options) {
        return this.enterprise.doSyncCoreContactData(options);
    }
    async doSyncCoreOrgData(options) {
        return this.enterprise.doSyncCoreOrgData(options);
    }
    async syncEnterpriseContactList(options) {
        return this.enterprise.syncEnterpriseContactList(options);
    }
    async syncSelfYunxin(params) {
        return this.enterprise.syncSelfYunxin(params);
    }
    async syncOrgList(options) {
        return this.enterprise.syncOrgList(options);
    }
    async getColleagueList() {
        return this.enterprise.getColleagueList();
    }
    async getResignList() {
        return this.enterprise.getResignList();
    }
    async getColleagueFolderList(colleagueAccId, subEmails) {
        return this.enterprise.getColleagueFolderList(colleagueAccId, subEmails);
    }
    async syncPersonContactList(options) {
        return this.personal.syncPersonContactList(options);
    }
    async syncPersonalOrgList(options) {
        return this.personal.syncPersonalOrgList(options);
    }
    transPersonalOrgToGroup(orgIdList) {
        return this.personal.transPersonalOrgToGroup(orgIdList);
    }
    resetContact() {
        return this.personal.resetContact();
    }
    async deletePersonalContact(_params) {
        return this.personal.deletePersonalContact(_params);
    }
    async updatePersonalContact(_params) {
        return this.personal.updatePersonalContact(_params);
    }
    async insertPersonalContact(_params) {
        return this.personal.insertPersonalContact(_params);
    }
    async insertPersonalOrg(params) {
        return this.personal.insertPersonalOrg(params);
    }
    async updatePersonalOrg(params) {
        return this.personal.updatePersonalOrg(params);
    }
    async insertPersonalContactByPersonalOrgId(params) {
        return this.personal.insertPersonalContactByPersonalOrgId(params);
    }
    async deletePersonalOrg(params) {
        return this.personal.deletePersonalOrg(params);
    }
    async uploadIcon(params) {
        return this.personal.uploadIcon(params);
    }
    async deleteAvartIcon() {
        return this.personal.deleteAvartIcon();
    }
    async personContactImport(params) {
        return this.personal.personContactImport(params);
    }
    async personContactExport(params) {
        return this.personal.personContactExport(params);
    }
    async personContactExportTemplate(type = 1) {
        return this.personal.personContactExportTemplate(type);
    }
    async batchOperatePersonalMark(params) {
        return this.personal.batchOperatePersonalMark(params);
    }
    async syncSelfCustomerList(lastId = 0) {
        return this.customer.syncSelfCustomerList(lastId);
    }
    async doGetCustomerListFromServer(params) {
        return this.customer.doGetCustomerListFromServer(params);
    }
    async doGetCustomersFromServerBatch(params) {
        return this.customer.doGetCustomersFromServerBatch(params);
    }
    async syncCustomerList(force) {
        return this.customer.syncCustomerList(force);
    }
    async syncClueList() {
        return this.customer.syncClueList();
    }
    async getCustomerListFilterByManagerId(idList, page) {
        return this.customer.getCustomerListFilterByManagerId(idList, page);
    }
    async getCustomerListByManagerId(params) {
        return this.customer.getCustomerListByManagerId(params);
    }
    async operateMailLsit(params) {
        return this.maillist.operateMailLsit(params);
    }
    async getMaillistMember(accountName) {
        return this.maillist.getMaillistMember(accountName);
    }
    async createMaillist(mailListMember) {
        return this.maillist.createMaillist(mailListMember);
    }
    async updateMaillist(mailListMember) {
        return this.maillist.updateMaillist(mailListMember);
    }
    async deleteMaillist(delMailListParams) {
        return this.maillist.deleteMaillist(delMailListParams);
    }
    async listUserDomain() {
        return this.maillist.listUserDomain();
    }
    async listUserMaillist(type) {
        return this.maillist.listUserMaillist(type);
    }
    async getMaillist(getMailListParams) {
        return this.maillist.getMaillist(getMailListParams);
    }
    async getMaillistConfig() {
        return this.maillist.getMaillistConfig();
    }
    async checkMaillistAccountName(mailListMember) {
        return this.maillist.checkMaillistAccountName(mailListMember);
    }
}
export const ContactServerInstance = new ContactServer();
